module.exports = __webpack_public_path__ + "static/media/23.282804b0.png";